import { useEffect, useState } from "react";
import Card from "../../../components/ui/Card";
import Button from "../../../components/ui/Button";

import {
  getContactMessages,
  markContactMessageAsRead,
  deleteContactMessage,
} from "../../../api/contactMessages.api";

import { MdPhone, MdEmail, MdDelete, MdMessage } from "react-icons/md";

const ContactMessages = () => {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(false);

  const load = async () => {
    setLoading(true);

    try {
      const res = await getContactMessages();
      setMessages(res.data || []);
    } catch (err) {
      console.error("Failed to load contact messages", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  const markAsRead = async (id) => {
    await markContactMessageAsRead(id);
    load();
  };

  const remove = async (id) => {
    const confirmed = window.confirm(
      "Delete this message?"
    );
    if (!confirmed) return;

    await deleteContactMessage(id);
    load();
  };

  return (
    <div className="space-y-6">
      <Card title="Contact Messages">
        {loading && "Loading..."}

        {!loading && messages.length === 0 && (
          <p className="text-sm text-gray-500">
            No contact messages yet.
          </p>
        )}

        {messages.map((m) => (
          <div
            key={m.id}
            className={`border rounded-xl p-4 mb-4 space-y-3 ${
              !m.isRead ? "bg-yellow-50" : ""
            }`}
          >
            <div className="flex justify-between items-start">
              <div>
                <h3 className="font-semibold text-lg text-[#28424d] flex items-center gap-2">
                  <MdMessage />
                  {m.name}
                </h3>

                <div className="flex items-center gap-2 text-sm text-gray-600">
                  <MdPhone />
                  {m.phone}
                </div>

                <div className="flex items-center gap-2 text-sm text-gray-600">
                  <MdEmail />
                  {m.email}
                </div>
              </div>

              {!m.isRead && (
                <span className="px-3 py-1 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800">
                  New
                </span>
              )}
            </div>

            <p className="text-sm">
              <b>Message:</b> {m.message}
            </p>

            <div className="text-xs text-gray-500">
              {new Date(m.createdAt).toLocaleString()}
            </div>

            <div className="flex gap-2 flex-wrap">
              {!m.isRead && (
                <Button
                  variant="outline"
                  onClick={() => markAsRead(m.id)}
                >
                  Mark as read
                </Button>
              )}

              <button
                onClick={() => remove(m.id)}
                className="text-red-500 hover:text-red-700"
              >
                <MdDelete size={20} />
              </button>
            </div>
          </div>
        ))}
      </Card>
    </div>
  );
};

export default ContactMessages;
